<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Marketplace Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newProduct()">New</a>
					<a href="#" @click="saveProduct()" v-if="product">Save</a>
					<a href="#" @click="deleteSelected()" v-if="product">Delete</a>
					<a href="#" @click="onLoad()" v-if="product">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">

		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>

		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="doDeleteSelected()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal>

		<div class="row">
			<div class="col-md-3 mb-4" v-if="products">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<small>{{products.length}} Products</small>
				<div class="leftSide">
					<b-table striped hover :filter="search" :items="products" :fields="[{key: 'name', label: 'Product'}, 'enabled', {key:'priority', label: 'P'}]" selectable select-mode="single" @row-clicked="selectProduct"></b-table>
				</div>
			</div>
			<div class="col-md-9" v-if="product">
				<div class="m-5 mt-0">
					<h2>{{product.name}}</h2>
					<div class="mb-2"><small>ID: {{product.id}}</small></div>
					<div class="row">
						<div class="col-md-4">
							Name: <b-form-input class="mb-2" v-model="product.name"></b-form-input>
						</div>
						<div class="col-md-4">
							Tags (, delimited): <b-form-input class="mb-2" v-model="product.tags"></b-form-input>
						</div>
						
						<div class="col-md-1">
							Priority: <b-form-input class="mb-2" v-model="product.priority"></b-form-input>
						</div>
						<div class="col-md-1">
							Enabled: <b-form-checkbox class="mb-2" v-model="product.enabled"></b-form-checkbox>
						</div>
						<div class="col-md-1">
							Featured: <b-form-checkbox class="mb-2" v-model="product.featured"></b-form-checkbox>
						</div>
					</div>
					
					<div class="row">
						<div class="col-md-4">
							Thumbnail (or calculator specific): <b-form-input class="mb-2" v-model="product.thumbnail"></b-form-input>
						</div>
						<div class="col-md-4">
							Featured Tag line: <b-form-input class="mb-2" v-model="product.featuredTagLine"></b-form-input>
						</div>
						<div class="col-md-4">
							Tag Line: <b-form-input class="mb-2" v-model="product.tagLine"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-5">
							Title: <b-form-input class="mb-2" v-model="product.title"></b-form-input>
						</div>
						<div class="col-md-5">
							Subtitle: <b-form-input class="mb-2" v-model="product.subTitle"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							Intro: <b-form-textarea rows="5" class="mb-2" v-model="product.intro"></b-form-textarea>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							Product page description: <b-form-textarea rows="5" class="mb-2" v-model="product.description"></b-form-textarea>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							Product page bullets (, delimited): <b-form-textarea rows="3" class="mb-2" v-model="product.bodyListItems"></b-form-textarea>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
						<p>Paragraphs:</p>
						</div>
						<div class="col-md-4">
							<b-button @click="addParagraph" variant="success">Add paragraph</b-button>
						</div>
						<div v-for="para in product.paragraphs" :key="para.id" >
							<div class="row">
								<div class="col-md-4">
									Heading: <b-form-input class="mb-2" v-model="para.title"></b-form-input>
								</div>
								<div class="col-md-4">
									<small>{{para.id}}</small>
								</div>
								<div class="col-md-12">
									Body: <b-form-input class="mb-2" v-model="para.body"></b-form-input>
								</div>
								<div class="col-md-4">
									<b-button @click="removeParagraph(para)">Delete</b-button>
								</div>
							</div>
							<p>--------------------------------</p>
						</div>
						
					</div>
					<div class="row">
						<div class="col-md-4">
							Product page img (or calculator type img): <b-form-input class="mb-2" v-model="product.backgroundImage"></b-form-input>
						</div>
						<div class="col-md-4">
							Product page CTA: <b-form-input class="mb-2" v-model="product.actionButtonText"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Website: <b-form-input class="mb-2" v-model="product.websiteUrl"></b-form-input>
						</div>
						<div class="col-md-4">
							App Screen: <b-form-input class="mb-2" v-model="product.appScreen"></b-form-input>
						</div>
						<div class="col-md-4">
							CMS Page: <b-form-input class="mb-2" v-model="product.cmsPage"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Employer ID (benefits only): <b-form-input class="mb-2" v-model="product.employerID"></b-form-input>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Products',
  data() {
	return{
		products: null,
		product: null,
		message: null,
		error: null,
		search: ""
	}
  },
  methods: {
	getProducts: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/Products?onlyEnabled=false")
			.then((result) => {
				this.products = result.data;
				
				if (autoSelect) {
					if (this.products.length > 0) {
						this.selectProduct(this.products[0]);
					}
				}
			}
		)
	},
	selectProduct: function(p) {
		this.product = p;
	},
	saveProduct: function(){
		if (this.product.id == null) {
			this.$http.post(this.$config.ApiUri + "/Products", this.product)
				.then((result) => {
					this.product = result.data;
					this.getProducts(false);
					this.showMessage("Product created OK!");
				}
			).catch(() => { this.showError(); });
		}
		else {
			this.$http.put(this.$config.ApiUri + "/Products/" + this.product.id, this.product)
				.then((result) => {
					this.product = result.data;
					this.getProducts(false);
					this.showMessage("Product saved OK!");
				}
			).catch(() => { this.showError(); });
		}
	},
	addParagraph: function() {
		this.product.paragraphs.push({
			title:"",
			body: ""
		});
	},
	removeParagraph: function(para) {
		var i = this.product.paragraphs.indexOf(para);
		this.product.paragraphs.splice(i, 1);
	},
	deleteSelected() {
		this.$bvModal.show('modSure');
	},
	doDeleteSelected() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Products/" + this.product.id)
			.then(() => {
				this.product = null;
				this.getProducts(true);
				this.showMessage("Product deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that Product cannot be deleted. (" + error + ")"); });
	},
	newProduct() {
		this.product = { 
			"id": null,
			"name": "",
			"featured": false,
			"tags": "",
			"priority": 0,
			"title": "",
			"subTitle": "",
			"tagLine": "",
			"description": "",
			"body": "",
			"bodyListItems": "",
			"actionButtonText": "",
			"backgroundImage": "",
			"backgroundVideo": "",
			"thumbnail": "",
			"websiteUrl": "",
			"appScreen": "",
			"cmsPage": "",
			"enabled": true
		};
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getProducts(true);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.filters
{
	margin-bottom: 10px;
	width: 100%;
}

.filters .btn-group
{
	width: 100%;
}

.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.actions-card {
	padding: 20px;
	margin-bottom: 10px;
	background-color:aliceblue;
}
</style>